import { render, staticRenderFns } from "./MRMR.vue?vue&type=template&id=6e8d6fb7"
import script from "./MRMR.vue?vue&type=script&lang=js"
export * from "./MRMR.vue?vue&type=script&lang=js"
import style0 from "./MRMR.vue?vue&type=style&index=0&id=6e8d6fb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports